import { SUBPHASES, appScreenKey } from './appScreens';
import { usePlace } from './lastPlace';
import { useScreenMemory } from './screenMemory';
import { PIPELINE } from './viewerPipelines';

// WHAT THE OPEN PHASE (AND SUBPHASE) OF THE APP ASKS OF THE DEVICE, reported per visit for Phase 7's
// table like a screen of the tutorial (see screenMemory). It counts every 3D view the page holds,
// the hidden phases' included: they stay mounted (see NoticeViewer), so that is what this phase
// costs while it is open. Draws nothing.
export function AppScreenMemory({ docId, phaseId }: { docId: string; phaseId: string }) {
  const def = SUBPHASES[phaseId];
  const [saved] = usePlace(docId, def?.slot ?? '');
  const n = PIPELINE.findIndex((p) => p.id === phaseId);
  const sub = def?.of(saved);
  const ord = n * 10 + Math.max(0, def?.subs.findIndex((s) => s.id === sub) ?? 0);
  useScreenMemory(n >= 0 ? `/api/notice/doc/${encodeURIComponent(docId)}/memory` : '', appScreenKey(phaseId, sub), ord);
  return null;
}
